import React, { useLayoutEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { logoURL } from "../../assets/images/logourl";
import { useStore } from "../../context/store.provider";
import { ROUTES_LINKS } from "../../routes/routes";
import { updateDB } from "../user/GettingData/firebase";
import "./EditProduct.css";
function EditProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  const { storeProducts } = useStore();
  const [product, setProduct] = useState({});
  useLayoutEffect(() => {
    // const prod = storeProducts.find((p) => p.id == params.id);
    // storeProducts.find((p) => p.id == params.id);
    // setProduct(prod);
    // console.log(Number(params.id));
    const match = (product) => {
      if (product.id == params.id) {
        setProduct(product);
      } else {
        console.log(product.id);
      }
    };
    storeProducts.forEach((product) => match(product));
  }, []);
  const onChangeName = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, productName: value }));
  };
  const onChangeCategory = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, category: value }));
  };
  const onChangeImg = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, imgUrl: value }));
  };
  const onChangePrice = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, price: value }));
  };
  const onChangeStorePrice = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, storePrice: value }));
  };
  const onChangeQuantity = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, quantity: value }));
  };
  const onChangeSalePrice = ({ target: { value } }) => {
    setProduct((prev) => ({ ...prev, salePrice: value }));
  };


  // useEffect(() => {
  //   if (!productNameValue === '' && !categoryValue === '') {

  //   }
  // }, [productNameValue, categoryValue])
  const sendProduct = async () => {
 
    // if its not finish with png or jpg
    const NewProduct = {
      productName: product.productName,
      category: product.category,
      imgUrl: product.imgUrl ? product.imgUrl : logoURL,
      quantity: product.quantity ? Number(product.quantity) :null,
      storePrice: Number(product.storePrice),
      price: Number(product.price),
      id: product.id,
      salePrice:product.salePrice?Number(product.salePrice):null,
      edited:true,
      outOfStock:product.quantity ==0 ? true : false
      // outOfStock:product.outOfStock? product.outOfStock: false
    };
    console.log(product.id);
    const identifier = product.id - 1;
    updateDB(NewProduct, identifier);
  };

  const handleNavigationToAdminSite = () => {
    navigate(ROUTES_LINKS.TO_ADMIN_SITE);
  };

  return (
    <div className="edit-product-edit">
      <div className="edit-product-form">
        <h2>EditProduct {params.id}</h2>
        <label htmlFor="productName">שם מוצר</label>
        <input onChange={onChangeName} value={product.productName} />
        <label htmlFor="category">קטגוריה</label>
        <input onChange={onChangeCategory} value={product.category} />
        <label htmlFor="category">תמונה</label>
        <input onChange={onChangeImg} value={product.imgUrl} placeholder='כתובת תמונה!!!' />
        <label htmlFor="category">מחיר קרן</label>
        <input
          onChange={onChangeStorePrice}
          type="number"
          value={product.storePrice}
          placeholder='מחיר קרן'
        />
        <label htmlFor="category">מחיר </label>
        <input onChange={onChangePrice} value={product.price} />
        <label htmlFor="category">מחיר מבצע</label>
        <input onChange={onChangeSalePrice} value={product.salePrice}   placeholder='מחיר מבצע' />
        <label htmlFor="category">כמות</label>
        <input
          onChange={onChangeQuantity}
          type="number"
          value={product.quantity}
          placeholder="כמות במלאי"
        />
        <button className="edit-btn-edit" onClick={sendProduct}>
          ערוך מוצר
        </button>
        <button
          className="back-to-store-btn"
          onClick={handleNavigationToAdminSite}
        >
          <i className="fa-solid fa-backward"></i> חזרה לאתר מנהל{" "}
        </button>
      </div>
    </div>
  );
}
//placeholder={name}
//placeholder={category}
//placeholder={imgUrl}
//placeholder={price }
export default EditProduct;
